export const EXLY_CREATEPAYMENTLINKS__REQUEST_UPCOMMING_OFFERINGS_FILTER =
  "@EXLY_CREATEPAYMENTLINKS__REQUEST_UPCOMMING_OFFERINGS_FILTER";

export const EXLY_CREATEPAYMENTLINKS__REQUEST_UPCOMMING_OFFERINGS =
  "@EXLY_CREATEPAYMENTLINKS/REQUEST_UPCOMMING_OFFERINGS";
export const EXLY_CREATEPAYMENTLINKS__SET_UPCOMMING_OFFERINGS =
  "@EXLY_CREATEPAYMENTLINKS/SET_UPCOMMING_OFFERINGS";
export const EXLY_CREATEPAYMENTLINKS__SHOW_UPCOMMING_OFFERINGS_LOADING =
  "@EXLY_CREATEPAYMENTLINKS/EXLY_CREATEPAYMENTLINKS__SHOW_UPCOMMING_OFFERINGS_LOADING";
export const EXLY_CREATEPAYMENTLINKS__RESET_UPCOMMING_OFFERINGS =
  "@EXLY_CREATEPAYMENTLINKS/EXLY_CREATEPAYMENTLINKS__RESET_UPCOMMING_OFFERINGS";
